@if (title) {
  <h3 class="h3 mbl">{{ title }}</h3>
}
@if (mixOptions) {
  <highcharts-chart
    [Highcharts]="Highcharts"
    [options]="mixOptions"
    [ngStyle]="{ display: 'block', width: '100%' }"
  ></highcharts-chart>
}
